module.exports = __webpack_public_path__ + "static/img/banner-1.2a14cfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner-1.jpg
// module id = qMYA
// module chunks = 1